// NOTE: this is a fork of boutique_renutriv_landing_formatter_v1 only changing wrapper classes
// so sidebar nav can safely be removed. Will not rebuild, minimizing risk.
// ESLint Settings
/* eslint complexity: "off", no-unused-labels: "off" */
/* globals platformCheck: true, site: true, TimelineMax: true, TweenMax: true, YT: true, Draggable: true, hashHelper: true, Spinner: true */

(function ($) {
  'use strict';

  Drupal.behaviors.boutiqueRenutrivLandingFormatterV2 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      // DOM
      var $window = $(window);
      var $body = $('body');
      var $boutique = $('#renutriv', context);
      var $sections = $boutique.find('section');
      var $videoModal = $boutique.find('.video_container');
      // LOGIC
      var platformVars = platformCheck({
        target: $boutique[0],
        mobileSize: 767,
        isMobileCallback: function () {
          return typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        }
      });
      var videoVars = {
        youtubeAPIReady: false,
        scrubberUpdateTimer: undefined,
        volumeSlider: undefined,
        volumeControlFadeout: undefined,
        player: undefined
      };
      var deeplinking = false;

      // Add brand body class so standalone styles are available
      $body.addClass('brand-style-renutriv');

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: Global Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // BEGIN: Events
        events: {
          $window
            .on('platformcheck-update', function (e) {
              // LOGIC
              var flag = e.originalEvent.detail.flag;

              // Desktop mobile width detection
              if (platformVars.isDesktop && (flag & platformCheck.FLAG_MOBILE)) {
                if ($boutique.hasClass('mobile')) {
                  $boutique.removeClass('mobile');
                  $window.trigger('desktopLostMobile');
                } else {
                  $boutique.addClass('mobile');
                  $window.trigger('desktopGainedMobile');
                }
              }

              if (platformVars.isIpad && (flag & platformCheck.FLAG_ORIENTATION)) {
                if (platformVars.orientation) {
                  $boutique.addClass('js-ipad-portrait');
                } else if (platformVars.orientation === false) {
                  $boutique.removeClass('js-ipad-portrait');
                }

                $window.trigger('orientationChanged');
              }
            });
        }
        // END: Events

        // BEGIN: Video Handling
        (function () {
          // DOM
          var $volumeKnob = $videoModal.find('.volume-slider .circle');
          // LOGIC
          var volumeControlFadeout;
          var volumeSlider;

          // Helper function to be hooked up to an interval that updates scrubber with current video progress
          function youtubeUpdateHandler() {
            var duration;
            var currentTime;
            var progress;

            if (typeof videoVars.player === 'undefined' || typeof videoVars.player.getDuration !== 'function') {
              return;
            }

            duration = videoVars.player.getDuration();
            currentTime = videoVars.player.getCurrentTime();
            progress = currentTime / duration;

            $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
          }

          function hideVolumeSlider() {
            if (volumeControlFadeout !== 'undefined') {
              clearTimeout(volumeControlFadeout);
            }

            volumeControlFadeout = setTimeout(function () {
              TweenMax.to($videoModal.find('.volume_btn .volume-slider'), 0.5, {
                opacity: 0,
                display: 'none',
                clearProps: 'all',
                onComplete: function () {
                  $videoModal.find('.volume_btn').removeClass('active');
                }
              });

              if (typeof volumeControlFadeout !== 'undefined') {
                clearTimeout(volumeControlFadeout);
              }

              volumeControlFadeout = undefined;
            }, 5000);
          }

          // BEGIN: Init
          init: {
            volumeSlider = Draggable.create($volumeKnob, {
              bounds: $volumeKnob.parent(),
              type: 'top',
              onDrag: function () {
                // LOGIC
                var progress = 1 - Math.abs(this.y / this.maxY);

                if (typeof videoVars.player !== 'undefined') {
                  videoVars.player.setVolume(100 * progress);
                } else {
                  $videoModal.find('video')[0].volume = progress;
                }

                hideVolumeSlider();
              }
            })[0];

            // Set up Youtube
            (function () {
              // DOM
              var tag = document.createElement('script');
              var firstScriptTag = document.getElementsByTagName('script')[0];

              window.onYouTubeIframeAPIReady = function () {
                // DOM
                videoVars.youtubeAPIReady = true;

                $window.trigger('youtubeready');
              };

              tag.src = 'https://www.youtube.com/iframe_api';
              firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            })();

            // Also set volume to 0 to allow autoplay
            // NOTE: Mute disables a ton USE AT OWN RISK
            if (platformVars.isMobile) {
              $videoModal.find('video')[0].volume = 0;
              $videoModal.find('video')[0].muted = false;
            }
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Open youtube modal then play youtube video via API
            $boutique.find('.video-container').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $videoTag = $videoModal.find('video');
              var $videoYoutube = $videoModal.find('.video');
              // LOGIC
              var videoID = $this.data('youtube-id');
              var videoURLMP4 = $this.data('video-url-mp4');
              var videoURLWEBM = $this.data('video-url-webm');
              var isVideoSet = false;

              e.preventDefault();
              e.stopPropagation();
              $window.trigger('videomodalopened');

              // Must have a youtube ID otherwise attempt to play normal video
              if (typeof videoID !== 'undefined' && videoID.trim().length !== 0) {
                $videoTag.css({ display: 'none' });
                $videoYoutube.css({ display: 'block' });

                TweenMax.fromTo($videoModal, 0.5, {
                  opacity: 0,
                  display: 'none'
                }, {
                  opacity: 1,
                  display: 'block',
                  className: '+=active'
                });

                videoVars.player = new YT.Player($videoYoutube[0], {
                  height: '360',
                  width: '640',
                  videoId: videoID,
                  playerVars: {
                    autoplay: 0, // Autoplay is handled via on ready
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3,
                    modestbranding: 1,
                    controls: 0,
                    start: 1,
                    playsinline: 1,
                    enablejsapi: 1
                  },
                  events: {
                    // Mute needed for mobile autoplay
                    onReady: function () {
                      if (!platformVars.isDesktop && platformVars.isMobile) {
                        videoVars.player.mute();
                      }
                      videoVars.player.playVideo();
                    },
                    onStateChange: function (e) {
                      var state = e.data;

                      // Unstarted/Play/Buffering
                      // Reveal video
                      if ((state === -1 || state === 1 || state === 3) && !platformVars.isMobile) {
                        videoVars.scrubberUpdateTimer = window.setInterval(youtubeUpdateHandler, 500);
                      // Ended
                      // Hide video
                      } else if (state === 0) {
                        $videoModal.find('.close_btn').trigger('click');
                      }
                    }
                  }
                });
              } else {
                $videoTag.css({ display: 'block' });
                $videoYoutube.css({ display: 'none' });
                // Clear URLS
                $videoTag.find('source').attr('src', '');

                if (/\.(mp4){1}$/gi.test(videoURLMP4)) {
                  $videoTag.find('source[type="video/mp4"]').attr('src', videoURLMP4);
                  isVideoSet = true;
                }

                if (/\.(webm){1}$/gi.test(videoURLWEBM)) {
                  $videoTag.find('source[type="video/webm"]').attr('src', videoURLWEBM);
                  isVideoSet = true;
                }

                // Attempt to load everything
                $videoTag[0].load();

                if (isVideoSet) {
                  $videoTag.one('canplay', function () {
                    this.play();
                  });

                  TweenMax.fromTo($videoModal, 0.5, {
                    opacity: 0,
                    display: 'none'
                  }, {
                    opacity: 1,
                    display: 'block',
                    className: '+=active'
                  });
                }
              }
            });

            // Video play button click
            $videoModal.find('.play_btn').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $video = $videoModal.find('video');

              e.preventDefault();

              if (!platformVars.isMobile) {
                // Clear existing video update timers
                if (typeof videoVars.scrubberUpdateTimer !== 'undefined') {
                  clearInterval(videoVars.scrubberUpdateTimer);
                }

                videoVars.scrubberUpdateTimer = setInterval(youtubeUpdateHandler, 500);
              }

              if (typeof videoVars.player !== 'undefined') {
                if ($this.hasClass('active')) {
                  videoVars.player.playVideo();
                  $this.removeClass('active');
                } else {
                  videoVars.player.pauseVideo();
                  $this.addClass('active');
                }
              } else {
                if ($this.hasClass('active')) {
                  $video[0].pause();
                } else {
                  $video[0].play();
                }
              }
            });

            $videoModal.find('.volume_btn').on('click', function (e) {
              // DOM
              var $this = $(this);

              e.preventDefault();

              if ($this.hasClass('active')) {
                $this.removeClass('active');
              } else {
                $this.addClass('active');

                hideVolumeSlider();
              }
            });

            // Volume slider click handling
            $videoModal.find('.volume_btn .line-container').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $volumeKnob = $this.find('.circle');
              // LOGIC
              var progress = ($this.offset().top - $window.scrollTop() - e.clientY) / $this.height();

              progress = Math.abs(Math.round(progress * 100) / 100);

              e.preventDefault();
              e.stopPropagation();

              TweenMax.set($volumeKnob, { top: volumeSlider.maxY * progress });

              if (typeof videoVars.player !== 'undefined') {
                videoVars.player.setVolume(100 * progress);
              } else {
                $videoModal.find('video')[0].volume = progress;
              }

              volumeSlider.update(true);
              volumeSlider.startDrag(e);
              volumeSlider.endDrag(e);

              hideVolumeSlider();
            });

            // Video scrubber click
            $videoModal.find('.scrubber-container').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $video = $videoModal.find('video');
              // LOGIC
              var position = e.clientX - $this.offset().left;
              var duration;
              var progress = position / $this.width();

              e.preventDefault();

              $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');

              if (typeof videoVars.player !== 'undefined' && typeof videoVars.player.getDuration === 'function') {
                duration = videoVars.player.getDuration();
                videoVars.player.seekTo(duration * progress);
              } else {
                $video[0].currentTime = $video[0].duration * progress;
              }
            });

            // Video fullscreen click
            $videoModal.find('.full_btn').on('click', function (e) {
              // DOM
              var $player;
              var $video = $videoModal.find('video');
              // LOGIC
              var requestFullScreen;

              e.preventDefault();

              // Must have an available player to do stuff
              if (typeof videoVars.player !== 'undefined') {
                $player = $videoModal.find('iframe');
                if ($player.length === 0) {
                  return;
                }
                requestFullScreen = $player[0].requestFullScreen || $player[0].mozRequestFullScreen || $player[0].webkitRequestFullScreen;
                requestFullScreen.call($player[0]);
              } else {
                requestFullScreen = $video[0].requestFullScreen || $video[0].mozRequestFullScreen || $video[0].webkitRequestFullScreen;
                requestFullScreen.call($video[0]);
              }
            });

            // Video close button click
            $videoModal.find('.close_btn').on('click', function (e) {
              // DOM
              var $video = $videoModal.find('video');

              e.preventDefault();
              e.stopPropagation();

              // Clear existing video update timers
              if (videoVars.scrubberUpdateTimer !== 'undefined') {
                window.clearInterval(videoVars.scrubberUpdateTimer);
              }

              if (typeof videoVars.player !== 'undefined') {
                videoVars.player.destroy();
                videoVars.player = undefined;
              } else {
                $video[0].pause();
                $video[0].currentTime = 0;
              }

              TweenMax.to($videoModal, 0.5, {
                opacity: 0,
                display: 'none',
                className: '-=active'
              });
            });

            $videoModal.find('video')
              .on('timeupdate', function () {
                var duration;
                var currentTime;
                var progress;

                duration = this.duration;
                currentTime = this.currentTime;
                progress = currentTime / duration;

                $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
              })
              .on('ended', function () {
                $videoModal.find('.close_btn').trigger('click');

                if (platformVars.isMobile) {
                  if (typeof this.webkitExitFullScreen === 'function') {
                    this.webkitExitFullScreen();
                  }
                }
              })
              .on('play playing', function () {
                $videoModal.find('.play_btn').addClass('active');
              })
              .on('pause', function () {
                $videoModal.find('.play_btn').removeClass('active');
              })
              .on('volumechange', function () {
                // DOM
                var $volumeButton = $videoModal.find('.volume_btn');
                // LOGIC
                var volume = this.volume * 100;

                // Reset
                $volumeButton.removeClass('vol-0 vol-1 vol-2 vol-3');

                if (volume === 0) {
                  $volumeButton.addClass('vol-0');
                } else if (volume <= 33) {
                  $volumeButton.addClass('vol-1');
                } else if (volume <= 66) {
                  $volumeButton.addClass('vol-2');
                } else if (volume > 66) {
                  $volumeButton.addClass('vol-3');
                }
              })
              .trigger('volumechange');
          }
          // END: Events
        })();
        // END: Video Handling

        // BEGIN: Scroll Handling
        // Functionality should only happen once preload completes
        $window.on('renutiv-preload-complete', function () {
          // Marks active sections
          $window.on('scroll', (function () {
            var prevScroll = 0;

            return function () {
              // DOM
              var $visibleSections = $sections.not(':hidden');
              var $target;
              // LOGIC
              var scrollTop = $window.scrollTop();
              var scrollBottom = scrollTop + $window.height();
              var dir = -(prevScroll - scrollTop);
              var candidates = [];

              dir = dir > 0 ? 1 : dir === 0 ? 0 : -1;

              // Mobile only, account for footer/header overlap
              if (platformVars.isMobile || platformVars.orientation) {
                // Include Renutriv footer
                $visibleSections = $visibleSections.add('#section-footer').not(':hidden');
              }

              // This was somehow getting the last step
              (dir === 1 ? $visibleSections : $($visibleSections.get().reverse())).each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var sectionTop = $this.offset().top - $('header').height() - (platformVars.isMobile ? $('#renutriv_nav').height() + $('.page-header').height() : 0);
                var sectionBottom = sectionTop + $this.outerHeight(true);
                var overlapPercent;

                if (scrollBottom >= sectionTop && sectionBottom >= scrollTop) {
                  overlapPercent = Math.max(0, Math.min(scrollBottom, sectionBottom) - Math.max(scrollTop, sectionTop) + 1) / $this.outerHeight(true);
                  candidates.push({
                    $element: $this,
                    overlap: overlapPercent
                  });
                }
              });

              candidates = candidates.sort(function (a, b) {
                var result = 0;

                if (a.overlap < b.overlap) {
                  result = 1;
                }

                if (a.overlap > b.overlap) {
                  result = -1;
                }

                // If both are revealed (has an overlap of 1), throw direction into the mix
                // Scrolling down prioritizes younger siblings
                // Scrolling up prioritizes older siblings
                if (a.overlap > 1 && b.overlap > 1) {
                  if (dir === 1) {
                    result = 1;
                  } else if (dir === -1) {
                    result = -1;
                  }
                }

                return result;
              });

              if (candidates.length !== 0) {
                $target = candidates[0].$element;
              } else {
                $target = $visibleSections.first();
              }

              // If a valid active class is found, mark it active, and remove that class from siblings
              if (typeof $target !== 'undefined' && !deeplinking) {
                if (!$target.hasClass('active')) {
                  $target.trigger('gainedActive');
                }

                $target.addClass('active');
                $sections.not($target).filter('.active').trigger('lostActive');
                $sections.not($target).removeClass('active');

                (function () {
                  // DOM
                  var $activeSections = $sections.filter('.active');
                  // LOGIC
                  var id;

                  if ($activeSections.length === 0) {
                    return;
                  }

                  id = $activeSections.first().attr('id');

                  if (typeof id !== 'undefined') {
                    hashHelper.set(id.replace('section-', ''));
                  }
                })();
              }

              prevScroll = scrollTop;
            };
          })());

          $window.trigger('scroll');
        });
        // END: Scroll Handling

        // BEGIN: Mobile Footer Nav
        (function () {
          // DOM
          var $self = $('#section-footer');
          // LOGIC
          var animation = new TimelineMax({ paused: true });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            animation
              .fromTo($self, 0.5, { opacity: 0 }, { opacity: 1 });
          }
          // END: Init

          // BEGIN: Events
          events: {
            $self.on('gainedActive', function () {
              animation.play();
            });
          }
          // END: Events
        })();
        // END: Mobile Footer Nav

        // BEGIN: Carousel Handling
        // NOTE: Animations should be handled through slideHasGainedActive
        // $window.on('renutiv-preload-complete', function() {
        (function () {
          // DOM
          // Ignore carousels within custom MPP
          var $carouselContainers = $boutique.find('.carousel_container').filter(function () {
            return $(this).closest('.custom-mpp').length !== 1;
          });
          // LOGIC
          var carouselTarget = '.carousel' + ($body.hasClass('device-pc') || $body.hasClass('device-mobile') ? ' .content' : '');
          var carouselSettings = {
            increment: '100%',
            offset: '0%',
            ignoreTargets: '.ignore',
            debug: false,
            useGSAP: false,
            duration: 1,
            callbackAnimation: function () {
              // DOM
              var $newSlide;
              var $otherSlides;
              // LOGIC
              var _this = this;
              var animation = new TimelineMax();

              $newSlide = _this.slides[0];
              $otherSlides = $newSlide.siblings();

              $newSlide.trigger('slideWillGainActive');
              $otherSlides.trigger('slideWillLoseActive'); // Signal that the last slide will lose active after animation

              animation
                .to($otherSlides, 0.5, {
                  opacity: 0,
                  display: 'none',
                  position: 'absolute',
                  className: '-=active'
                })
                .to($newSlide, 0.5, {
                  opacity: 1,
                  display: 'block',
                  position: 'relative',
                  className: '+=active'
                }, '0')
                .add(function () {
                  $newSlide.trigger('slideHasGainedActive');
                  _this.$target.trigger('carousel_updated', $newSlide.index());
                });
            }
          };

          // BEGIN: Init
          init: {
            $carouselContainers.each(function () {
              // DOM
              var $this = $(this);
              var $carousel = $this.find(carouselTarget);
              var $carouselDotContainer = $this.find('.carousel_pagination ul');

              carouselSettings.$dot_container = $carouselDotContainer;
              carouselSettings.$dot_template = $carouselDotContainer.find('.template');

              // Enable carousel and controls for mobile and landscape iPad
              if (!platformVars.isMobile && $carousel.children().length > 1) {
                $carousel.elCarousel(carouselSettings);
                $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'block' });
              // Otherwise hide controls and make "first" slide the active slide
              } else {
                // Carousel children needs active to be visible
                $carousel.children().first().addClass('active');
                $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'none' });
              }
            });
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Global stopper for blank a tags in carousels
            $carouselContainers.find('a[href=""]').on('click', function (e) {
              e.preventDefault();
            });

            // Carousel progression via arrow click
            $carouselContainers.find('.carousel_pagers li').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $carousel = $this.closest('.carousel_container').find(carouselTarget);

              e.preventDefault();

              if ($this.hasClass('previous')) {
                $carousel.elCarouselPrev();
              } else if ($this.hasClass('next')) {
                $carousel.elCarouselNext();
              }
            });

            // Carousel navigation via dot nav click
            $carouselContainers.find('.carousel_pagination ul li').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $carousel = $this.closest('.carousel_container').find(carouselTarget);
              // LOGIC
              var index = $this.index() - 1;

              e.preventDefault();

              $this.addClass('active').siblings().removeClass('active');

              $carousel.elCarouselTo(index);
            });

            // Dot nav update on carousel update
            $carouselContainers.on('carousel_updated', function (e, index) {
              $(this).find('.carousel_pagination ul li').eq(index + 1).addClass('active').siblings().removeClass('active');
            });

            // Carousel progression via swipe
            $carouselContainers.find(carouselTarget).swipe({
              swipeLeft: function () {
                $(this).elCarouselNext();
              },
              swipeRight: function () {
                $(this).elCarouselPrev();
              },
              excludedElements: 'button, input, select, textarea, .noSwipe',
              preventDefaultEvents: false
            });

            // Carousel progression via keyboard directional key press
            $window
              .on('keydown', function (e) {
                // Find carousels in active sections
                $carouselContainers.each(function () {
                  // DOM
                  var $this = $(this);
                  var $carousel = $this.find(carouselTarget);

                  // Container section must be active
                  if ($this.closest('section.active').length === 0) {
                    return;
                  }

                  switch (e.which) {
                    // Previous
                    case 37:
                      $carousel.elCarouselPrev();
                      break;

                      // Next
                    case 39:
                      $carousel.elCarouselNext();
                      break;
                  }
                });
              })
            // Destroy carousel in mobile mode
              .on('desktopGainedMobile', function () {
                $carouselContainers.find(carouselTarget).elCarouselDestroy().children().removeAttr('style');
                $carouselContainers.find(carouselTarget).children().first().addClass('active').siblings().removeClass('active');
                $carouselContainers.find('.carousel_pagers, .carousel_pagination').css({ display: 'none' });
              })
            // Rebuild carousel
              .on('desktopLostMobile', function () {
                $carouselContainers.each(function () {
                  // DOM
                  var $this = $(this);
                  var $carousel = $this.find(carouselTarget);
                  var $carouselDotContainer = $this.find('.carousel_pagination ul');

                  carouselSettings.$dot_container = $carouselDotContainer;
                  carouselSettings.$dot_template = $carouselDotContainer.find('.template');

                  // Enable carousel for desktop
                  if (!platformVars.isMobile && $carousel.children().length > 1) {
                    $carousel.elCarousel(carouselSettings);
                    $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'block' });
                  } else {
                    // Carousel children needs active to be visible
                    $carousel.children().first().addClass('active').siblings().removeClass('active');
                    $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'none' });
                  }

                  // Carousel children needs active to be rendered
                  $carousel.children().first().addClass('active');
                });
              });
          }
          // END: Events
        })();
        // });
        // END: Carousel Handling
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: Global Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  BEGIN: ReNutriv - Landing Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        if (!$boutique.hasClass('renutriv-landing')) {
          return;
        }

        // BEGIN: Global Functionality
        (function () {
          // LOGIC
          var animation = new TimelineMax({ paused: true });

          // BEGIN: Init
          init: {
            animation
              .fromTo($boutique, 1, { backgroundPosition: '0 500%' }, { backgroundPosition: '0 65%' });
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Progress bottom page "stars" movement
            $window.on('scroll', function () {
              // LOGIC
              var scrollTop = $window.scrollTop();
              var scrollMax = $boutique.outerHeight(true) - (platformVars.orientation ? $window.height() : 0);
              var progress = scrollTop / scrollMax;

              progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;

              animation.progress(progress);
            });
          }
          // END: Events
        })();
        // END: Global Functionality

        // BEGIN: Section 1
        (function () {
          // DOM
          var $self = $('#section-landing');
          var $video;
          // LOGIC
          var animation = new TimelineMax({ paused: true });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            $video = $self.find('video');

            animation
              .to($self.find('.mp4-container'), 0.5, { opacity: 1 })
              .to($self.find('.background'), 0.5, { opacity: 0 }, '0');
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Play intro animation once video starts playing
            $video.on('playing', function () {
              animation.play();
            });

            $videoModal.find('.close_btn').on('click', function (e) {
              var $targetVideo = $video.filter(platformVars.isMobile ? '.mobile' : '.desktop');

              e.preventDefault();

              if ($video.length !== 0) {
                $targetVideo[0].play();
              }
            });

            $window.on('videomodalopened', function () {
              $video.each(function () {
                this.pause();
              });
            })
              .one('renutiv-preload-complete', function () {
                var $targetVideo = $video.filter(platformVars.isMobile ? '.mobile' : '.desktop');

                if ($video.length !== 0) {
                  $targetVideo[0].play();
                }
              })
              .on('desktopGainedMobile desktopLostMobile orientationChanged', function () {
                var $targetVideo = $video.filter(platformVars.isMobile ? '.mobile' : '.desktop');

                $video.each(function () {
                  this.pause();
                });

                if ($video.length !== 0) {
                  $targetVideo[0].play();
                }
              });

            // Clear intro animation if desktop/mobile changes
            $window.on('desktopGainedMobile desktopLostMobile', function () {
              animation.kill();
              $self.find('.mp4-container').removeAttr('style');
              $self.find('.background').removeAttr('style');
            });
          }
          // END: Events
        })();
        // END: Section 1

        // BEGIN: Section 2
        (function () {
          // DOM
          var $self = $('#ultimate-diamond');
          var $carousel = $self.find('.carousel_container .carousel' + ($body.hasClass('device-pc') || $body.hasClass('device-mobile') ? ' .content' : ''));
          var $carouselSlides = $carousel.find('.slide');
          var introAnimation = new TimelineMax({ paused: true });
          var introAnimationPlayed = false;

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            if (!platformVars.isMobile) {
              introAnimation
                .fromTo($self.find('.background'), 0.5, { opacity: 0 }, { opacity: 1 });
            }

            // Create animation per slide
            $carouselSlides.each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var animation = new TimelineMax({ paused: true });

              animation
                .staggerFromTo($this.find('.tile-description').find(
                  'h3' + (platformVars.isMobile ? '.mobile' : '.desktop') + ',' +
                  'h2' + (platformVars.isMobile ? '.mobile' : '.desktop') + ',' +
                  (platformVars.isMobile ? '.mobile' : '.desktop') + ' > p,' +
                  '.el-product_shop-now-container'
                ), 0.5, {
                  opacity: 0,
                  y: '20%'
                }, {
                  opacity: 1,
                  y: '0%'
                }, 0.25)
                .addCallback(function () {
                  $this.removeData('animation');
                })
                .addPause();

              $this.data('animation', animation);
            });
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Play slide animation if available
            $carouselSlides.on('slideHasGainedActive', function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var animation = $this.data('animation');

              if (typeof animation === 'undefined' || (!$self.hasClass('active') && !introAnimationPlayed)) {
                return;
              }
              animation.play(0);
            });

            // Section active event
            $self.one('gainedActive', function () {
              // DOM
              var $activeSlide = $carouselSlides.filter('.active');
              // LOGIC
              var animation = $activeSlide.data('animation');

              if (typeof animation === 'undefined') {
                return;
              }

              if (introAnimationPlayed) {
                animation.play(0);
              } else {
                animation.play(0);
                introAnimation.add(animation);
                introAnimation.play();
                introAnimationPlayed = true;
              }
            });

            $self.on('deeplink', function (e, data) {
              if (data.deeplinkData.length > 1) {
                $carousel.elCarouselTo(parseInt(data.deeplinkData[1]));
              }
            });

            // Clear intro animation if desktop/mobile changes
            // Clear animation from all slides
            $window.on('desktopGainedMobile desktopLostMobile', function () {
              introAnimation.kill();

              $self.find('.background').removeAttr('style');

              $carouselSlides.each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var animation = $this.data('animation');

                if (typeof animation !== 'undefined') {
                  animation.kill();
                }

                $this.find('.tile-description').find('h3, h2, .mobile > p, .desktop > p, .el-product_shop-now-container').removeAttr('style');
              });
            });
          }
          // END: Events
        })();
        // END: Section 2

        // BEGIN: Section 3
        (function () {
          // DOM
          var $self = $('#ultimate-lift');
          var $carousel = $self.find('.carousel_container .carousel' + ($body.hasClass('device-pc') || $body.hasClass('device-mobile') ? ' .content' : ''));
          var $carouselSlides = $carousel.find('.slide');
          var introAnimation = new TimelineMax({ paused: true });
          var introAnimationPlayed = false;

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            introAnimation
              .fromTo($self.find('.background'), 0.5, { opacity: 0 }, { opacity: 1 });

            // Create animation per slide
            $carouselSlides.each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var animation = new TimelineMax({ paused: true });

              animation
                // .fromTo($this.find('.background'), 0.5, {opacity: 0}, {opacity: 1})
                .staggerFromTo($this.find('.tile-description').find(
                  'h2' + (platformVars.isMobile ? '.mobile' : '.desktop') + ',' +
                  'h3' + (platformVars.isMobile ? '.mobile' : '.desktop') + ',' +
                  (platformVars.isMobile ? '.mobile' : '.desktop') + ' > p,' +
                  '.el-product_shop-now-container'
                ), 0.5, {
                  opacity: 0,
                  y: '20%'
                }, {
                  opacity: 1,
                  y: '0%'
                }, 0.25)
                .addCallback(function () {
                  $this.removeData('animation');
                })
                .addPause();

              $this.data('animation', animation);
            });
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Play slide animation if available
            $carouselSlides.on('slideHasGainedActive', function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var animation = $this.data('animation');

              if (typeof animation === 'undefined' || (!$self.hasClass('active') && !introAnimationPlayed)) {
                return;
              }

              animation.play(0);
            });

            // Section active event
            $self.one('gainedActive', function () {
              // DOM
              var $activeSlide = $carouselSlides.filter('.active');
              // LOGIC
              var animation = $activeSlide.data('animation');

              if (typeof animation === 'undefined') {
                return;
              }

              if (introAnimationPlayed) {
                animation.play(0);
              } else {
                animation.play(0);
                introAnimation.add(animation);
                introAnimation.play();
                introAnimationPlayed = true;
              }
            });

            $self.on('deeplink', function (e, data) {
              if (data.deeplinkData.length > 1) {
                $carousel.elCarouselTo(parseInt(data.deeplinkData[1]));
              }
            });

            // Clear intro animation if desktop/mobile changes
            // Clear animation from all slides
            $window.on('desktopGainedMobile desktopLostMobile', function () {
              introAnimation.kill();

              $self.find('.background').removeAttr('style');

              $carouselSlides.each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var animation = $(this).data('animation');

                if (typeof animation !== 'undefined') {
                  animation.kill();
                }

                $this.find('.tile-description').find('h3, h2, .mobile > p, .desktop > p, .el-product_shop-now-container').removeAttr('style');
              });
            });
          }
          // END: Events
        })();
        // END: Section 3

        // BEGIN: Section 4
        (function () {
          // DOM
          var $self = $('#section-heritage');
          // LOGIC
          var animation = new TimelineMax({ paused: true });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            animation
              .fromTo($self.find('.background'), 1, { opacity: 0 }, { opacity: 1 })
              .staggerFromTo($self.find('.tile-description').find('h2, h3, p, .el-product_shop-now-container'), 0.5, {
                opacity: 0,
                y: '20%'
              }, {
                opacity: 1,
                y: '0%'
              }, 0.25, '-=0.8');
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Play intro animation when section takes up view
            $self.one('gainedActive', function () {
              animation.play();
            });

            // Clear intro animation if desktop/mobile changes
            // Clear animation from all slides
            $window.on('desktopGainedMobile desktopLostMobile', function () {
              animation.kill();

              $self.find('.background').removeAttr('style');
              $self.find('.tile-description').find('h2, h3, p, .el-product_shop-now-container').removeAttr('style');
            });
          }
          // END: Events
        })();
        // END: Section 4
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  END: ReNutriv - Landing Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  BEGIN: ReNutriv - Heritage Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        if (!$boutique.hasClass('heritage')) {
          return;
        }

        // BEGIN: Section 1
        (function () {
          // DOM
          var $self = $('#section-landing');
          var $sectionImages;
          var $quoteContainer;
          // LOGIC
          var animationIntro = new TimelineMax({ paused: true });
          var animationIntroPlaying = false;

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            $sectionImages = $self.find('img').not('.tile-description img, .signature');
            $quoteContainer = $self.find('.tile-description');

            // Grab string, make spans
            (function () {
              // DOM
              var $quote = $quoteContainer.find('h2 span');

              $quote.each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var letters = $this.html().split('');
                var result = '';

                letters.forEach(function (letter) {
                  result += '<span>' + letter + '</span>';
                });

                $this.html(result);
              });
            })();

            TweenMax.set($sectionImages.filter('.second'), { opacity: 0 });
            TweenMax.set($self.find('p'), {
              opacity: 0,
              y: '20%'
            });

            animationIntro
              .fromTo($sectionImages.filter('.first' + (platformVars.isMobile ? ', .second' : '')), 1, { opacity: 0 }, { opacity: 1 });

            // Animate the per letter animation
            $quoteContainer.find('h2 > span').not(':hidden').each(function () {
              animationIntro
                .staggerFromTo($(this).find('span'), 1, { opacity: 0 }, { opacity: 1 }, 0.05, '0');
            });

            animationIntro
              .fromTo($self.find('.signature'), 1, { opacity: 0 }, { opacity: 1 }, '-=0.5');

            if (!platformVars.isMobile) {
              animationIntro
                .to($sectionImages.filter('.second'), 1, { opacity: 1 });
            }

            animationIntro
              .staggerTo($self.find('p').not(':hidden'), 0.5, {
                opacity: 1,
                y: '0%'
              }, 0.25, '-=0.5');

            $self.data('animation', animationIntro);
          }
          // END: Init

          // BEGIN: Events
          events: {
            $self.on('gainedActive', function () {
              if (animationIntroPlaying) {
                return;
              }

              animationIntroPlaying = true;
              animationIntro.play(0);
            });

            // Clear intro animation if desktop/mobile changes
            // Clear animation from all slides
            $window.on('desktopGainedMobile desktopLostMobile', function () {
              animationIntro.kill();

              $self.find('*').removeAttr('style');
            });
          }
          // END: Events
        })();
        // END: Section 1

        // BEGIN: Section 2
        (function () {
          // DOM
          var $self = $('#section-carousel');
          var $carousel = $self.find('.carousel' + ($body.hasClass('device-pc') || $body.hasClass('device-mobile') ? ' .content' : ''));
          var $carouselSlides = $carousel.find('.slide');
          // LOGIC
          var parallaxTimeline = new TimelineMax({ paused: true });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            // Create animation for parallax effect
            parallaxTimeline
              .fromTo($self.find('.slide .background'), 1, {
                y: '0%',
                scale: platformVars.isMobile ? 1.5 : 1
              }, {
                y: '-50%',
                scale: platformVars.isMobile ? 1.5 : 1
              }, '0');

            // Create individual slide animations
            $carouselSlides.each(function () {
              // DOM
              var $this = $(this);
              var $quoteContainer = $this.find('.tile-description');
              // LOGIC
              var animation = new TimelineMax({ paused: true });

              // Grab string, make spans
              (function () {
                // DOM
                var $quote = $quoteContainer.find('h2' + (platformVars.isMobile ? '.mobile' : '.desktop') + ' span');

                $quote.each(function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var letters = $this.html().split('');
                  var result = '';

                  letters.forEach(function (letter) {
                    result += '<span>' + letter + '</span>';
                  });

                  $this.html(result);
                });
              })();

              animation
                .addCallback(function () {
                  $this.removeData('animation');
                });

              // Animate the per letter animation
              $quoteContainer.find('h2' + (platformVars.isMobile ? '.mobile' : '.desktop') + ' > span').not(':hidden').each(function () {
                animation
                  .staggerFromTo($(this).find('span'), 1, { opacity: 0 }, { opacity: 1 }, 0.05, '0');
              });

              animation
                .fromTo($quoteContainer.find('img'), 1, { opacity: 0 }, { opacity: 1 }, '-=0.5');

              $this.data('animation', animation);
            });
          }
          // END: Init

          // BEGIN: Events
          events: {
            $self.on('deeplink', function (e, data) {
              if (data.deeplinkData.length > 1) {
                $carousel.elCarouselTo(parseInt(data.deeplinkData[1]));
              }
            });

            $carouselSlides.on('slideHasGainedActive', function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var animation = $this.data('animation');

              if (typeof animation === 'undefined' || !$self.hasClass('active')) {
                return;
              }

              animation.play(0);
            });

            // Section active event
            $self.one('gainedActive', function () {
              // DOM
              var $activeSlide = $carouselSlides.filter('.active');
              // LOGIC
              var animation = $activeSlide.data('animation');

              if (typeof animation === 'undefined') {
                return;
              }

              animation.play(0);
            });

            // Progress animation on scroll to create a parallax effect
            $window.on('scroll', function () {
              // LOGIC
              var currentPoint = $window.scrollTop() + $window.height() - $self.offset().top;
              var endPoint = $self.height() + $window.height();
              var progress = currentPoint / endPoint;

              progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;

              parallaxTimeline.progress(progress);
            });

            // Clear intro animation from each slide
            $window.on('desktopGainedMobile desktopLostMobile', function () {
              $carouselSlides.each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var animation = $this.data('animation');

                if (typeof animation !== 'undefined') {
                  animation.kill();
                }

                $this.find('*').removeAttr('style');
              });
            });
          }
          // END: Events
        })();
        // END: Section 2

        // BEGIN: Section 3
        (function () {
          // DOM
          var $self = $('#section-heritage-video');
          // LOGIC
          var animation = new TimelineMax({ paused: true });
          var animationPlaying = false;

          // BEGIN: Init
          init: {
            if (platformVars.isMobile) {
              animation
                .staggerFromTo($self.find('.tile-description > div p').not(':hidden'), 0.5, {
                  opacity: 0,
                  y: '20%'
                }, {
                  opacity: 1,
                  y: '0%'
                }, 0.25, '0.5')
                .staggerFromTo($self.find('.image-container img').not(':hidden'), 1, { opacity: 0 }, { opacity: 1 }, 0.5)
                .staggerFromTo($self.find('.tile-description .logo-container').not(':hidden').children(), 0.5, {
                  opacity: 0,
                  y: '20%'
                }, {
                  opacity: 1,
                  y: '0%'
                }, 0.25);
            } else {
              animation
                .staggerFromTo($self.find('.image-container img').not(':hidden'), 1, { opacity: 0 }, { opacity: 1 }, 0.5)
                .staggerFromTo($self.find('h2, h3, p, .logo-container img').not(':hidden'), 0.5, {
                  opacity: 0,
                  y: '20%'
                }, {
                  opacity: 1,
                  y: '0%'
                }, 0.25, '0.5');
            }
          }
          // END: Init

          // BEGIN: Events
          events: {
            $self.on('gainedActive', function () {
              if (animationPlaying) {
                return;
              }

              animationPlaying = true;

              animation.play(0);
            });

            // Clear intro animation if desktop/mobile changes
            // Clear animation from all slides
            $window.on('desktopGainedMobile desktopLostMobile', function () {
              animation.kill();

              $self.find('*').removeAttr('style');
            });
          }
          // END: Events
        })();
        // END: Section 3
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  END: ReNutriv - Heritage Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  BEGIN: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $loader = $('#loader');
        var $deeplinkSection;
        var $targetImages;
        // LOGIC
        var deeplinkData = hashHelper.get();
        var spinnerOptions = {
          lines: 17, // The number of lines to draw
          length: 0, // The length of each line
          width: 5, // The line thickness
          radius: 26, // The radius of the inner circle
          scale: 1, // Scales overall size of the spinner
          corners: 1, // Corner roundness (0..1)
          color: '#ffffff', // #rgb or #rrggbb or array of colors
          opacity: 0.5, // Opacity of the lines
          rotate: 0, // The rotation offset
          direction: 1, // 1: clockwise, -1: counterclockwise
          speed: 1, // Rounds per second
          trail: 30, // Afterglow percentage
          zIndex: 2e9, // The z-index (defaults to 2000000000)
          className: 'spinner', // The CSS class to assign to the spinner
          top: '50%', // Top position relative to parent
          left: '50%', // Left position relative to parent
          shadow: false, // Whether to render a shadow
          hwaccel: true, // Whether to use hardware acceleration
          position: 'absolute' // Element positioning
        };
        var spinner = new Spinner(spinnerOptions).spin($loader[0]);

        // Default to first section in page
        if (deeplinkData.length === 0) {
          $deeplinkSection = $boutique.find('section').first();
        } else {
          // Attempt to find section without '#section-'
          $deeplinkSection = $boutique.find('#' + deeplinkData[0]);

          if ($deeplinkSection.length === 0) {
            // Attempt to find section with '#section-'
            $deeplinkSection = $boutique.find('#section-' + deeplinkData[0]);

            // Default to first section
            if ($deeplinkSection.length === 0) {
              $deeplinkSection = $boutique.find('section').first();
            }
          }
        }

        deeplinking = true;

        // Get all images before the target section images as well, as content may be sized to loaded images
        $targetImages = $deeplinkSection.add($deeplinkSection.prevAll()).find('img');
        $targetImages.FreeLoader({
          callback: function () {
            // LOGIC
            var animation = new TimelineMax({ delay: 1 });

            // Mark boutique as loaded
            $boutique.addClass('loaded');

            //  Load other (boutique) images normally
            $boutique.find('img').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var imageLink = $this.attr('data-src');

              if (typeof imageLink === 'string' && imageLink.trim().length !== 0) {
                $this.attr('src', imageLink);
              }
            });

            spinner.stop();

            animation
              .to($loader, 1, {
                opacity: 0,
                display: 'none',
                onComplete: function () {
                  $window.trigger('renutiv-preload-complete');

                  if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
                    $deeplinkSection.trigger('deeplink', { deeplinkData: deeplinkData });
                  }

                  deeplinking = false;
                  $window.trigger('scroll');
                  $window.trigger('loadAnimationComplete');
                }
              });

            // MPP has no deeplink
            if (!$boutique.hasClass('mpp')) {
              animation.addCallback(function () {
                var scrollValue = 0;

                // Get target scroll value if a deep link section exists
                if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
                  // Get Deeplink scroll amount
                  // If the section content is larger than window, scroll to top
                  if ($deeplinkSection.height() > $window.height() || platformVars.isMobile) {
                    scrollValue = $deeplinkSection.offset().top - $('header').height() - (platformVars.isMobile ? $('#renutriv_nav').height() : 0);
                  // Otherwise scroll so that the section content is in the middle of the page
                  } else {
                    scrollValue = $deeplinkSection.offset().top - ($window.height() - $deeplinkSection.height()) / 2 - $('header').height();
                  }

                  if ($deeplinkSection.is($boutique.find('section').first())) {
                    scrollValue = 0;
                  }
                }

                if (scrollValue !== 0) {
                  TweenMax.to($window, 1, {
                    scrollTo: {
                      y: scrollValue,
                      autoKill: false
                    },
                    onComplete: function () {
                      deeplinking = false;
                      $window.trigger('scroll');
                      $window.trigger('loadAnimationComplete');
                    }
                  });
                }
              });
            }
          }
        });
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  END: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
    }
  };
})(jQuery);
